import { useResponsiveValue } from "../useResponsiveValue/useResponsiveValue.mjs";
import { resolveResponsiveRangeProps } from "../../utils/resolveResponsiveRangeProps.mjs";
const ResponsiveRender = ({ children, above, below }) => {
  const [hiddenOnMobile, hiddenOnTablet, hiddenOnDesktop, hiddenOnWide] = resolveResponsiveRangeProps({ above, below });
  const renderComponent = useResponsiveValue()({
    mobile: hiddenOnMobile,
    tablet: hiddenOnTablet,
    desktop: hiddenOnDesktop,
    wide: hiddenOnWide
  });
  return renderComponent ? children : null;
};
export {
  ResponsiveRender
};
